/**
 * Auth Module — route definitions
 *
 * Uses the SAME paths as the legacy auth routes so all existing navigation
 * (from legacy components, bookmarks, etc.) hits the new code.
 *
 * The corresponding legacy routes in Router.jsx are commented out.
 */
import React, { lazy } from 'react';
import { Route } from 'react-router';

const GuestGuard = lazy(() => import('./shared/components/GuestGuard'));

const LoginForm = lazy(() => import('./login'));
const PinVerification = lazy(() => import('./pin-verification'));
const OtpScreen = lazy(() => import('./otp'));
const PinCreation = lazy(() => import('./pin-creation'));
const ResetPassword = lazy(() => import('./reset-password'));
const AffiliateSelect = lazy(() => import('./affiliate-select'));

// Called as a plain function (not rendered as a component) so react-router
// sees the <Route> elements as direct children of <Routes>.
export const AuthRoutes = (): React.ReactElement => (
  <>
    <Route
      path="/auth/login"
      element={
        <GuestGuard>
          <LoginForm />
        </GuestGuard>
      }
    />
    <Route path="/otp" element={<OtpScreen />} />
    <Route
      path="/passcode-verification"
      element={
        <GuestGuard>
          <PinVerification />
        </GuestGuard>
      }
    />
    <Route path="/create-passcode" element={<PinCreation />} />
    <Route path="/auth/reset-password" element={<ResetPassword />} />
    <Route path="/welcome" element={<AffiliateSelect />} />
  </>
);

export default AuthRoutes;
